<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="订单ID" prop="orderId" >
        <a-input v-model="form.orderId" placeholder="请输入订单ID" />
      </a-form-model-item>
      <a-form-model-item label="商品ID" prop="goodsId" >
        <a-input v-model="form.goodsId" placeholder="请输入商品ID" />
      </a-form-model-item>
      <a-form-model-item label="分类ID" prop="categoryId" >
        <a-input v-model="form.categoryId" placeholder="请输入分类ID" />
      </a-form-model-item>
      <a-form-model-item label="调机米数ID" prop="machineId" >
        <a-input v-model="form.machineId" placeholder="请输入调机米数ID" />
      </a-form-model-item>
      <a-form-model-item label="刀具费用id多个，拼接id" prop="toolIds" >
        <a-input v-model="form.toolIds" placeholder="请输入刀具费用id多个，拼接id" />
      </a-form-model-item>
      <a-form-model-item label="复合材料其他成本费用(id多个,拼接)" prop="compositeMaterials" >
        <a-input v-model="form.compositeMaterials" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="调机成本的其他费用(id多个,拼接)" prop="machineTuning" >
        <a-input v-model="form.machineTuning" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="颜色调整费" prop="colorAdjustment" >
        <a-input v-model="form.colorAdjustment" placeholder="请输入颜色调整费" />
      </a-form-model-item>
      <a-form-model-item label="复合材料合格率" prop="passRate" >
        <a-input v-model="form.passRate" placeholder="请输入复合材料合格率" />
      </a-form-model-item>
      <a-form-model-item label="类型：默认0" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入名称" />
      </a-form-model-item>
      <a-form-model-item label="图标" prop="url" >
        <a-input v-model="form.url" placeholder="请输入图标" />
      </a-form-model-item>
      <a-form-model-item label="描述" prop="description" >
        <a-input v-model="form.description" placeholder="请输入描述" />
      </a-form-model-item>
      <a-form-model-item label="产品详情" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrderGoods, addOrderGoods, updateOrderGoods } from '@/api/user/orderGoods'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        orderId: null,

        goodsId: null,

        categoryId: null,

        machineId: null,

        toolIds: null,

        compositeMaterials: null,

        machineTuning: null,

        colorAdjustment: null,

        passRate: null,

        type: null,

        name: null,

        url: null,

        description: null,

        content: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        orderId: null,
        goodsId: null,
        categoryId: null,
        machineId: null,
        toolIds: null,
        compositeMaterials: null,
        machineTuning: null,
        colorAdjustment: null,
        passRate: null,
        type: null,
        name: null,
        url: null,
        description: null,
        content: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrderGoods({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrderGoods(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrderGoods(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
